const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLengde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 449.146 205.885 C 449.146 294.272 396.719 347.137 341.961 402.219 C 308.867 434.38 276.967 467.685 245.01 500.989 C 213.111 467.685 181.154 434.38 148.06 402.219 C 93.359 347.137 40.022 294.272 40.022 205.885 C 40.022 178.927 45.322 152.23 55.608 127.324 C 65.894 102.419 80.974 79.787 99.983 60.727 C 118.992 41.661 141.555 26.542 166.393 16.227 C 191.23 5.906 217.847 0.601 244.726 0.601 C 271.611 0.601 298.228 5.906 323.065 16.227 C 347.903 26.542 370.466 41.661 389.475 60.727 C 408.484 79.787 423.564 102.419 433.85 127.324 C 444.136 152.23 449.43 178.927 449.43 205.885 L 449.146 205.885 Z",
    fill: "white",
    style: {},
    transform: "matrix(0.9999999999999999, 0, 0, 1, -1.1368683772161603e-13, 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8152060508728025, 0, 0, -1.8152060508728027, 38.80967794650769, 411.9589015528121)",
    id: "g10",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#f14824",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2264.03,1132.19 c 0,623.52 -508.32,1131.85 -1131.84,1131.85 C 509.395,2264.04 1.07422,1755.71 1.07422,1132.19 1.07422,509.398 509.395,1.08203 1132.19,1.08203 c 623.52,0 1131.84,508.31597 1131.84,1131.10797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "none",
      stroke: "#f14824",
      strokeWidth: 2.1500001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 2264.03,1132.19 c 0,623.52 -508.32,1131.85 -1131.84,1131.85 C 509.395,2264.04 1.07422,1755.71 1.07422,1132.19 1.07422,509.398 509.395,1.08203 1132.19,1.08203 c 623.52,0 1131.84,508.31597 1131.84,1131.10797 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1981.07,1132.19 c 0,467.29 -380.88,848.9 -848.88,848.9 -467.28,0 -848.159,-381.61 -848.159,-848.9 0,-466.549 380.879,-848.151 848.159,-848.151 468,0 848.88,381.602 848.88,848.151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "none",
      stroke: "#f14824",
      strokeWidth: 2.1500001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 1981.07,1132.19 c 0,467.29 -380.88,848.9 -848.88,848.9 -467.28,0 -848.159,-381.61 -848.159,-848.9 0,-466.549 380.879,-848.151 848.159,-848.151 468,0 848.88,381.602 848.88,848.151 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "rgb(35, 31, 32)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1347.56 1192.016 L 1347.56 896.133 L 1441.629 896.133 L 1441.629 1210.835 C 1441.629 1287.794 1378.346 1352.786 1299.671 1352.786 C 1251.782 1352.786 1205.603 1330.552 1174.818 1294.633 C 1147.475 1330.552 1104.694 1352.786 1060.224 1352.786 C 1024.309 1352.786 988.391 1337.392 962.737 1313.452 L 962.737 1339.108 L 868.668 1339.108 L 868.668 896.133 L 962.737 896.133 L 962.737 1192.016 C 962.737 1289.502 1108.114 1289.502 1108.114 1192.016 L 1108.114 896.133 L 1202.183 896.133 L 1202.183 1192.016 C 1202.183 1289.502 1347.56 1289.502 1347.56 1192.016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "rgb(35, 31, 32)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 663.112 866.208 L 352.3 1067.004 C 335.667 1078.532 335.667 1104.116 352.3 1114.346 L 663.112 1316.44 C 677.179 1325.377 696.366 1315.162 696.366 1298.53 C 696.366 1295.974 695.081 1294.691 695.081 1293.414 L 663.112 1164.232 L 787.173 1164.232 L 787.173 1018.416 L 663.112 1018.416 L 695.081 889.232 C 695.081 887.937 696.366 885.396 696.366 884.119 C 696.366 872.607 686.13 862.357 674.617 862.357 C 670.786 862.357 666.942 863.655 663.112 866.208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "rgb(35, 31, 32)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1620.09 872.405 L 1926.872 1070.599 C 1935.709 1076.929 1939.497 1084.482 1939.497 1094.607 C 1939.497 1103.442 1935.709 1112.257 1926.872 1117.326 L 1620.09 1316.801 C 1617.565 1319.328 1613.795 1319.328 1608.728 1319.328 C 1597.365 1319.328 1588.528 1310.485 1588.528 1299.123 C 1588.528 1296.601 1588.528 1295.334 1588.528 1294.075 L 1621.352 1166.566 L 1498.892 1166.566 L 1498.892 1022.64 L 1621.352 1022.64 L 1588.528 895.132 C 1588.528 893.852 1588.528 891.344 1588.528 890.084 C 1588.528 878.721 1597.365 868.604 1608.728 868.604 C 1613.795 868.604 1617.565 869.886 1620.09 872.405"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengde);
export default __webpack_public_path__ + "static/media/lengde.6db4aebfaf20b3317780290bd832dd2c.svg";
export { ForwardRef as ReactComponent };